import axios from 'axios'
export default {

  async add (order) {
    try {
      const response = await axios.post('orders/add', order)
      if (response.status === 200) {
        return response.data
      } else {
        console.log('Hubo un problema al agregar stock:', response.data)
        return null
      }
    } catch (error) {
      console.error('Error al agregar stock:', error)
      return null
    }
  },

  async listByBussines (businesId, search, page, startDate, endDate, status, limit) {
    try {
      const response = await axios.get(
        'orders/listByBusiness?id=' + businesId +
        '&search=' + search +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&status=' + status +
        '&limit=' + limit)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPos (terminalId, search, page, startDate, endDate, status, limit) {
    try {
      const response = await axios.get(
        'orders/listByPos?id=' + terminalId +
        '&search=' + search +
        '&page=' + page +
        '&startDate=' + startDate +
        '&endDate=' + endDate +
        '&status=' + status +
        '&limit=' + limit)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  }

}
